<template>
  <el-main>
    <query-gather :is-add="authorityMap.isAdd" :is-input="true" :is-query="true" :is-reset="true"
                  :cur-input-tip="curInputTip"
                  style="margin-top: -2vh"
                  @qgAddDeal="addItemDeal" @qgQueryDeal="qgQuery"
                  @qgResetDeal="resetSkwtDataDeal"></query-gather>
    <div class="commonDiv">
      <el-table
          :data="skwtTableData"
          v-loading="loading"
          element-loading-text="拼命加载中"
          element-loading-spinner="el-icon-loading"
          border
          ref="skwtTableRef"
          size="mini"
          @selection-change="tableSelectionChange"
          @sort-change="skwtSortChange"
          :row-style="tableRowClassName"
          max-height="calc(100% - 60px)"
          style="width: 100%;"
          height="calc(100% - 60px)"
          :header-cell-style="{backgroundColor:'#f9f9ff',fontSize: '1.6rem',textAlign:'center',color:'#323232',
                          fontFamily:'PingFang SC',fontWeight:'normal',fontStretch:'normal',height:'6.5vh'}">
        <template v-for="(item,index) in skwtTitles">
          <template v-if="index ===0">
            <el-table-column
                :prop="item.prop"
                :width="item.width"
                :label="item.label"
                :align="item.align"
                :sortable="item.sortable"
                show-overflow-tooltip>
              <template slot-scope="scope">
                <a style="color: #46adf5; cursor: pointer;"
                   @click="skwtClickDeal(scope.row)">{{ scope.row.bh }}</a>
              </template>
              <template v-for="(child,index) in item.children" v-show="item.children">
                <el-table-column
                    :prop="child.prop"
                    :width="child.width"
                    :label="child.label"
                    :align="child.align"
                    :sortable="child.sortable"
                    show-overflow-tooltip
                ></el-table-column>
              </template>
            </el-table-column>
          </template>
          <template v-else>
            <el-table-column
                :prop="item.prop"
                :width="item.width"
                :label="item.label"
                :align="item.align"
                :sortable="item.sortable"
                show-overflow-tooltip
            >
              <template v-for="(child,index) in item.children" v-show="item.children">
                <el-table-column
                    :prop="child.prop"
                    :width="child.width"
                    :label="child.label"
                    :align="child.align"
                    :sortable="child.sortable"
                    show-overflow-tooltip
                ></el-table-column>
              </template>
            </el-table-column>
          </template>
        </template>
        <el-table-column label="操作" align="center" width="100" v-if="authorityMap.isDel">
          <template slot-scope="scope">
            <el-tooltip content="删除" effect="light" v-if="authorityMap.isDel">
              <el-popconfirm
                  title="确定删除吗？"
                  @confirm="skwtItemDeleteDeal(scope.row)"
              >
                <img
                    src="~@/assets/images/operates/delete.png"
                    alt=""
                    slot="reference"
                    style="cursor: pointer;width: 3.5vh;height: 3.5vh;"
                />
              </el-popconfirm>
            </el-tooltip>
          </template>
        </el-table-column>

      </el-table>
      <div class="commonPage2">
        <el-pagination
            @size-change="skwtHandleSizeChange"
            @current-change="gzHandleCurrentChange"
            :page-sizes="[10, 20, 30]"
            :page-size="params.size"
            :current-page="params.current"
            layout="total, prev, pager, next,sizes, jumper"
            background
            :total="params.total"
        >
        </el-pagination>
      </div>
    </div>
    <data-dialog :dialog-title="skwtDialog.title" :is-visible="skwtDialog.skwtFormVisible" :is-read="isRead"
                 :is-own-style="true"
                 :dg-style="dgStyle"
                 @dgVerifyDeal="dgVerifyDeal('skwtDialog','dialog')" ref="skwtDialog"
                 @dgConfirmDeal="dgSkwtConfirmDeal"
                 @dgCancelDeal="dgCancelDeal">
      <div slot="dialogFrom">
        <el-form ref="dialog" :model="skwtDialog.data" :rules="skwtRules" label-width="100px" label-position="top"
                 :disabled="isRead"
                 class="commonForm">
          <el-row>
            <el-col :span="12">
              <el-form-item label="编号" prop="bh" style="width: 70%;">
                <el-input v-model="skwtDialog.data['bh']" clearable :disabled="!this.isAddData"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="名称" prop="mc" style="width: 70%;">
                <el-input v-model="skwtDialog.data['mc']" clearable></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="序号" prop="xh" style="width: 70%;">
                <el-input v-model="skwtDialog.data['xh']" clearable></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </data-dialog>
  </el-main>
</template>

<script>
import BottomPagination from "../../components/tableGather/bottomPagination";
import DataDialog from "../../components/tableGather/dataDialog";
import QueryGather from "../../components/buttonGather/queryGather";

/**
 * @Author: ygh
 * @Date: 2024/5/22 15:31
 * @Description:水库问题数据管理页面
 */
export default {
  name: "skwt",
  mounted() {
    this.initSkwtData();
  },
  components: {BottomPagination, DataDialog, QueryGather},
  data() {
    let validateBhNum = (rule, value, callback) => {
      if (value == null || value.length == 0) {
        callback();
      } else {
        if (value.length <= 20) {
          let reg = /^[a-zA-Z0-9_\-+#@]*$/;
          if (reg.test(value)) {
            callback();
          } else {
            return callback(new Error("只能包含a-z、A-Z、0-9及_-+#@特殊字符"));
          }
        } else {
          return callback(new Error("长度不能超过20个字符"));
        }
      }
    };
    let validateXhNum = (rule, value, callback) => {
      if (value == null || value.length == 0) {
        callback();
      } else {
        const reg = /^[0-9][0-9]*$/;
        if (reg.test(value)) {
          value = value + '';
          if (value.length > 9) {
            return callback(new Error("序号长度不超过9个字符"));
          }
          callback();
        } else {
          return callback(new Error("序号只能填0-9的数字"));
        }
      }
    };
    let validateMcLen = (rule, value, callback) => {
      if (value == null || value.length == 0) {
        callback();
      } else {
        if (value.length > 50) {
          return callback(new Error("长度不能超过50个字符"));
        } else {
          return callback();
        }
      }
    };
    return {
      authorityMap: {
        isAdd: false,//新增权限
        isUpdate: false,//修改权限
        isDel: false,//删除权限
        isView: false,//查看权限
      },
      isRead: false,
      isAddData:false,
      stRemHeight: 0,
      curInputTip: '请输入编号或者名称',
      staffDataArr: [],
      skwtTitles: [
        {
          prop: 'bh', label: '编号', width: 180, align: 'center', sortable: false,
        },
        {
          prop: 'mc', label: '名称', width: null, align: 'center', sortable: false,
        }, {
          prop: 'xh', label: '序号', width: 120, align: 'center', sortable: true,
        },
      ],
      skwtTableData: [],
      skwtRules: {
        mc: [
          {required: true, message: "请输入名称", trigger: "blur"},
          {validator: validateMcLen, trigger: 'blur'},
        ],
        xh: [
          {required: true, message: "请输入序号", trigger: "blur"},
          {validator: validateXhNum, trigger: 'blur'},
        ],
        bh: [
          {required: true, message: "请输入编号", trigger: "blur"},
          {validator: validateBhNum, trigger: 'blur'},
        ],
      },
      params: {
        total: 1,
        size: 10,
        current: 1,
      },
      loading: false,
      skwtMultiple: true,
      skwtMultipleSelection: [],
      curInputValue: '',
      jzwMcOptions: [],//水库问题options
      dgStyle: {
        height: '45%',
        marginTop: '0',
      },
      skwtDialog: {
        title: "",
        skwtFormVisible: false,
        data: {
          "mc": "",
          "xh": "",
          "bh": "",
        },
      },
      dialogData: {
        "mc": "",
        "xh": "",
        "bh": "",
      },
    }
  },
  created() {
    let windowHeight =
        document.documentElement.clientHeight || document.bodyclientHeight;
    this.stRemHeight = windowHeight / 100;
  },
  methods: {
    initSkwtData() {
      this.pageAuthorityDeal();
      this.getSkwtData();
    },
    pageAuthorityDeal() {
      const thirdAuthority = JSON.parse(localStorage.getItem("thirdAuthority"))
      const qx = thirdAuthority[this.$route.name];
      if (qx === 'all' || qx === null) {
        this.authorityMap.isAdd = true;
        this.authorityMap.isDel = true;
        this.authorityMap.isUpdate = true;
        this.authorityMap.isView = true;
      } else {
        this.authorityMap.isAdd = qx.indexOf('新增') !== -1;
        this.authorityMap.isDel = qx.indexOf('删除') !== -1;
        this.authorityMap.isUpdate = qx.indexOf('修改') !== -1;
        this.authorityMap.isView = qx.indexOf('查询') !== -1;
      }
      // console.log("当前页面三级菜单权限", thirdAuthority, this.authorityMap);
    },
    dgCancelDeal() {
      if (this.skwtDialog.skwtFormVisible) {
        this.skwtDialog.skwtFormVisible = false;
        this.$refs['dialog'].clearValidate();
      }
    },
    dgSkwtConfirmDeal() {
      this.isRead = false;
      if (this.isAddData) {
        this.addSkwt();
      } else {
        this.updateSkwt();
      }
    },
    dgVerifyDeal(dgRef, frRef) {
      this.$refs[frRef].validate((valid) => {
        if (valid) {
          this.$refs[dgRef].isShowPop(true);
        } else {
          this.$refs[dgRef].isShowPop(false);
        }
      });
    },
    addSkwt() {
      this.request.post('/rm-swtxx/v1/addWtxx', this.skwtDialog.data).then(res => {
        if (res.ok) {
          this.skwtDialog.skwtFormVisible = false;
          this.skwtDialog.data = {};
          this.isAddData = false;
          this.$message.success('成功添加水库问题信息');
          this.getSkwtData();
        } else {
          this.$message.error(res.error.message);
        }
      });
    },
    updateSkwt() {
      // console.log("======updateSkwt======", this.skwtDialog.data);
      this.request.post('/rm-swtxx/v1/modifyWtxx', this.skwtDialog.data).then(res => {
        if (res.ok) {
          this.skwtDialog.skwtFormVisible = false;
          this.skwtDialog.data = {};
          this.isAddData = false;
          this.$message.success('成功修改水库问题信息');
          this.getSkwtData();
        } else {
          this.$message.error(res.error.message);
        }
      });
    },
    resetSkwtDataDeal() {
      this.curInputValue = '';
      this.clearTableStatus();
      this.getSkwtData();
    },
    clearTableStatus() {
      this.$refs.skwtTableRef.clearSort();
    },
    initgetSkwtData() {
      this.params = {
        total: 0,
        size: 10,
        current: 1,
      };
      this.getSkwtData();
    },
    qgQuery(params) {
      this.curInputValue = params.curInputValue;
      this.clearTableStatus();
      this.getSkwtData();
    },
    addItemDeal() {
      this.skwtDialog.title = '新增水库问题信息';
      this.skwtDialog.skwtFormVisible = true;
      this.skwtDialog.data = {...this.dialogData};
      this.isAddData = true;
      this.isRead = false;
      // console.log("======addItemDeal======", this.skwtDialog, this.btnIndex);
    },
    skwtItemDeleteDeal(row) {
      this.request.delete('/rm-swtxx/v1/delWtxx/' + row['id']).then(res => {
        if (res.ok) {
          this.$message.success("数据删除成功");
          this.initgetSkwtData();
        } else {
          this.$message.error(res.error.message);
        }
      });
    },
    skwtSortChange(column) {
      let params = {
        total: 0,
        size: 10,
        current: 1,
        order: column.order === "descending" ? 1 : 0,
      };
      this.params = {};
      this.params = params;
      this.getSkwtData();
    },
    tableSelectionChange(val) {
      this.skwtMultiple = !val.length;
      this.skwtMultipleSelection = val;
    },
    skwtClickDeal(row) {
      if (this.authorityMap.isView || this.authorityMap.isUpdate) {
        this.isAddData = false;
        this.setSkwtDataToDialog(row);
      }
    },
    setSkwtDataToDialog(row) {
      this.skwtDialog.title = '修改水库问题信息'
      this.skwtDialog.skwtFormVisible = true;
      this.isRead = this.authorityMap.isView && !this.authorityMap.isUpdate;
      this.skwtDialog.data = {};
      this.skwtDialog.data = {...row};
      // console.log("======skwt======", this.skwtDialog.data);
    },
    tableRowClassName({row, rowIndex}) {
      return {
        backgroundColor: '#ffffff',
        fontSize: '1.4rem',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontFamily: 'PingFang SC',
        color: '#616f7b',
        height: '6.55vh',
      };
    },
    skwtHandleSizeChange(val) {
      this.params.size = val;
      this.params.current = 1;
      this.getSkwtData();
    },
    //切换页码
    gzHandleCurrentChange(val) {
      this.params.current = val;
      this.getSkwtData();
    },
    getSkwtData() {
      this.loading = true;
      let params = {
        ...this.params,
        bhmc: this.curInputValue + '',
      };
      this.request.get('/rm-swtxx/v1/queryWtxxPage', {params: params}).then(res => {
        // console.log(res, '===getSkwtDataRes===');
        if (res.ok) {
          if (res.data != null) {
            this.skwtTableData = res.data['records'];
            this.params.total = res.data['total'];
            this.params.size = res.data['size'];
          } else {
            this.$message.info("获取水库问题信息数据为空");
          }
        } else {
          this.$message.error(res.error.message);
        }
        this.loading = false;
      });
    },
  },
  watch: {
    "$store.state.head.skCd"() {
      this.resetSkwtDataDeal();
    }
  }

}
</script>

<style scoped>
.commonForm {
  padding-top: 4vh;
  padding-left: 6vh;
}

.commonDiv {
  position: relative;
  background-color: #FFFFFF;
  height: calc(100vh - 200px);
}

/deep/ .el-pagination {
  white-space: nowrap;
  color: #303133;
  font-weight: 700;
  transform: translate(0, -50%);
  position: relative;
  top: 50%;
  right: 20px;
}

.commonPage2 {
  position: absolute;
  right: 1.5rem;
  height: 60px;
}


</style>
